import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {AudienceSegment, AudienceSegmentData} from "types/AudienceSegment";
import deserializeAudienceSegment from "services/ngage/deserializers/audience-segment";
import {snakeKeys, withoutEmpty} from "../array";
import DataResource from "../../types/DataResource";

type AudienceSegmentFilters = {
  search?: string | null
  sort?: string | null
  page?: number
  perPage?: number
}

/**
 * Get all audience segments (paginated)
 */
const all = async (page: number = 1) => {
  const response = await client.get<DataPage<AudienceSegment> | null>(`/audience-segments?page=${page}`)

  if (response.data) {
    response.data.data = response.data.data.map(deserializeAudienceSegment)
  }

  return response.data
}

/**
 * Get all audience segments that match the given filters (paginated)
 */
const filtered = async (filters: AudienceSegmentFilters = {}) => {
  const params = Object.assign({page: 1, per_page: 100}, snakeKeys(withoutEmpty(filters)))
  const response = await client.get<DataResource<AudienceSegment> | null>('/audience-segments', {params})

  if (response.data) {
    response.data.data = response.data.data.map(deserializeAudienceSegment);
  }

  return response.data
}

/**
 * Get a single audience segment
 *
 * @param {number} id
 */
const get = async (id: number) => {
  const response = await client.get<AudienceSegment>(`/audience-segments/${id}`)
  return deserializeAudienceSegment(response.data)
}

/**
 * Store a new audience segment
 *
 * @param data
 */
const store = async (data: AudienceSegmentData) => {
  const response = await client.post<AudienceSegment>('/audience-segments', data)
  return deserializeAudienceSegment(response.data)
}

/**
 * Update an existing audience segment
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: AudienceSegmentData) => {
  const response = await client.put<AudienceSegment>(`/audience-segments/${id}`, data)
  return deserializeAudienceSegment(response.data)
}

/**
 * Permanently delete a audience segment
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
  const response = await client.delete<null>(`/audience-segments/${id}`)
  return response.status === 204
}

const audienceSegments = {
  all,
  filtered,
  get,
  store,
  update,
  destroy
}

export default audienceSegments;